var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Page", { attrs: { title: _vm.title } }, [
    _c(
      "div",
      { staticClass: "pageView-index" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shows,
                expression: "shows"
              }
            ],
            staticClass: "logo"
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/img/logo.png"), alt: "" }
            })
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.list, function(items, index) {
          return _c("div", { key: index, staticClass: "menu_list_flex" }, [
            _c("div", { staticClass: "menu_headerTitl" }, [
              _vm._v(_vm._s(items.name))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex" },
              _vm._l(items.subMenuList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "menu_list",
                    on: {
                      click: function($event) {
                        return _vm.navigation_(item.id, item)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: item.icon
                          ? _vm.http + item.icon
                          : require("@/assets/img/1.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "menu_list_font" }, [
                      _vm._v(_vm._s(item.name))
                    ]),
                    _vm._v(" "),
                    item.num != 0
                      ? _c("div", { staticClass: "statues" }, [
                          _vm._v(_vm._s(item.num))
                        ])
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-826af616", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-826af616","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/index.vue
// module id = null
// module chunks = 